var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], { autoescape: true });
} else {
	env = nunjucks.currentEnv;
}
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/Users/aaronphy/gitlab/lazada/node_modules/_nunjucks-loader@2.4.8@nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["src/component/baseui/templates/frame.html"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
var macro_t_1 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
var callerFrame = frame;
frame = new runtime.Frame();
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
var t_2 = "";t_2 += "\n      <header class=\"m-alicare-header\">\n        <nav class=\"nav-bar\">\n          <div class=\"J_Back head-back\" role=\"button\" aria-label=\"back\">\n              <span class=\"iconfont icon-arrow\"></span>\n          </div>\n          <section class=\"caption\">\n              LazBot  \n          </section>\n          <div class=\"right-nav\">\n              <span class=\"iconfont icon-close\"></span>\n          </div>\n        </nav>\n      </header>\n      <div class=\"m-alicare-body\">\n          <div class=\"m-alicare-scroller\" tabindex=\"-1\">\n          </div>\n      </div>\n      <div class=\"m-alicare-footer\"></div>\n";
;
frame = callerFrame;
return new runtime.SafeString(t_2);
});
context.addExport("base");
context.setVariable("base", macro_t_1);
output += "\n\n";
var macro_t_3 = runtime.makeMacro(
[], 
[], 
function (kwargs) {
var callerFrame = frame;
frame = new runtime.Frame();
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
var t_4 = "";t_4 += "\n  <!-- 预置 -->\n  <div class=\"m-footer-slideup J_SlideUp\"></div>\n  <div class=\"J_InputWrap m-input-wrap\">\n      <div class=\"m-shortcuts-wrap J_Shortcuts\">\n      </div>\n      <div class=\"m-input-toolbar J_InputToolbar\">\n          <div class=\"m-input-toolbar-panel\">\n              <!--输入-->\n              <div class=\"m-input-form J_InputForm\">\n              </div>\n          </div>\n      </div>\n      <!--扩展-->\n      <div class=\"m-input-form-ext J_ExtPanel\">\n          <div class=\"plugins J_Plugins\"></div>\n      </div>\n  </div>\n";
;
frame = callerFrame;
return new runtime.SafeString(t_4);
});
context.addExport("footer");
context.setVariable("footer", macro_t_3);
output += "\n\n\n";
var macro_t_5 = runtime.makeMacro(
["speech"], 
[], 
function (l_speech, kwargs) {
var callerFrame = frame;
frame = new runtime.Frame();
kwargs = kwargs || {};
if (kwargs.hasOwnProperty("caller")) {
frame.set("caller", kwargs.caller); }
frame.set("speech", l_speech);
var t_6 = "";t_6 += "\n    ";
if(l_speech) {
t_6 += "\n    <!--语音输入-->\n    <div class=\"btn-switch J_BtnSwitch\">\n        <button class=\"btn switch-voice\" aria-label=\"切换到语音输入\">\n             <svg class=\"icon voice\" aria-hidden=\"true\">\n                <use xlink:href=\"#icon-mic\"></use>\n             </svg>\n             <svg class=\"icon keyboard\" aria-hidden=\"true\">\n                <use xlink:href=\"#icon-keyboard\"></use>\n            </svg>  \n        </button>\n    </div>\n    ";
;
}
t_6 += "\n    <div class=\"panel J_Panel\">\n      <div class=\"m-input-wrap\">\n        <div class=\"keyboard-wrap\">\n            <textarea placeholder=\"\" class=\"textarea J_Field\"></textarea>\n            <textarea class=\"textarea-copy J_InputFieldCopy\"></textarea>\n            <input type=\"number\" class=\"input J_NumberField\">\n            <span class=\"m-emoji-btn J_EmojiBtn\">\n                <i class=\"iconfont icon-emoji\"></i>\n            </span>\n        </div>\n        ";
if(l_speech) {
t_6 += "\n        <!--语音输入-->\n        <div class=\"voice-wrap J_Voice press-speech\">\n            <div class=\"press-text\" role=\"button\" aria-label=\"按住说话\">\n                <svg class=\"icon micc\" aria-hidden=\"true\">\n                    <use xlink:href=\"#icon-micc\"></use>\n                </svg>\n                <span>按住 说话</span>\n            </div>\n            <div class=\"loosen-text\" role=\"button\" aria-label=\"松开发送\">\n                <svg class=\"icon mic\" aria-hidden=\"true\">\n                    <use xlink:href=\"#icon-mic\"></use>\n                </svg>\n                <span>松开 发送</span>\n            </div>\n        </div>\n        ";
;
}
t_6 += "\n      </div>\n        \n    </div>\n    <div class=\"m-input-btn J_InputBtn\">\n        <button class=\"btn send-btn J_SendMessageButton\" role=\"button\" aria-label=\"发送\">\n           <i class=\"iconfont icon-send\"></i>\n        </button>\n    </div>\n";
;
frame = callerFrame;
return new runtime.SafeString(t_6);
});
context.addExport("input");
context.setVariable("input", macro_t_5);
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["src/component/baseui/templates/frame.html"] , dependencies)


//////////////////
// WEBPACK FOOTER
// ./src/component/baseui/templates/frame.html
// module id = 149
// module chunks = 0 1